import {createSelector} from "reselect";
import {getAllProperties, getSelectedController} from "./controllers.selectors";

const toolsTab = (state) => state.toolsTab;

export const getEthernetConfigurationsNew = createSelector(
  toolsTab,
  (data) => data.etheretConfigurationsNew
);

export const getPortForwardingConfigurations = createSelector(
  toolsTab,
  (data) => data.portForwardingConfigurations
);

export const portForwardingTableData = createSelector(
  getPortForwardingConfigurations,
  (configs) => {
    const headers = configs?.length
      ? configs[0].field_definition.map((field) => field.slug)
      : [];
    const data = [];
    configs.forEach((eachConfig) => {
      const tableRowObject = {};
      eachConfig.field_definition.forEach((field) => {
        tableRowObject[field.slug] = field.field_value;
      });
      data.push({
        ...tableRowObject,
        config: eachConfig,
      });
    });
    return {headers, data};
  }
);

export const getAllconfigurations = createSelector(
  getEthernetConfigurationsNew,
  getPortForwardingConfigurations,
  (ethernet, portForwarding) => [...ethernet, ...portForwarding]
);

export const getModbusTcpIp = createSelector(toolsTab, (data) => data.modbusTcpIp);

export const getCellularModem = createSelector(toolsTab, (data) => data.cellularModem);

export const getAquaticGroupProfiles = createSelector(
  toolsTab,
  (data) => data.aquaticGroupProfiles || []
);

export const portForwardingStatus = createSelector(
  getAllProperties,
  (data) => data?.feature_port_fwd
);

export const emailTransmissionStatus = createSelector(
  getSelectedController,
  (data) => data.is_email_transmission
);
